import type { ISystem, ISystemGroup } from '../types';
import { isSystem } from './isSystem';
import { mapSystems } from './mapSystems';

export const mapGroups = (_: ISystemGroup) => ({
  ..._,
  childGroups: _?.childGroups?.map((g_OR_s: ISystem | ISystemGroup) =>
    isSystem(g_OR_s) ? mapSystems(g_OR_s) : mapGroups(g_OR_s),
  ),
});
